import { useEffect, useState } from 'react';

/**
 * `true` quan la finestra és més estreta que `breakpoint` (768 px per defecte).
 *
 * Vivia dins de `ReservationPopover` (Sprint 32, l'overlay a pantalla completa del
 * calendari). El calendari històric necessita exactament el mateix comportament, així que
 * s'ha tret aquí tal qual: mateix `matchMedia`, mateix valor inicial, mateixa neteja.
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
